import { ChangeDetectionStrategy, Component, QueryList, ViewChildren } from '@angular/core';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { MatButtonModule } from '@angular/material/button';
import { KanbanBoardStore } from '@store';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-refresh-snapshot-button',
  standalone: true,
  imports: [CommonStandaloneModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './refresh-snapshot-button.component.html',
  styleUrls: ['./refresh-snapshot-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefreshSnapshotButtonComponent {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  constructor(public kanbanBoardStore: KanbanBoardStore) {}
}
